/**
 * Calculate straight-line distance between two points using simple geometry
 */
export function calculateDistance(point1: [number, number], point2: [number, number]): number {
    const latDiff = point1[0] - point2[0];
    const lngDiff = point1[1] - point2[1];
    return Math.sqrt(latDiff * latDiff + lngDiff * lngDiff);
}

/**
 * Calculate distance in meters between two points using the Haversine formula
 */
export function getDistanceMeters(a: [number, number], b: [number, number]): number {
    const R = 6371000; // Earth's radius in meters
    const toRad = (d: number) => d * Math.PI / 180;
    const dLat = toRad(b[0] - a[0]);
    const dLon = toRad(b[1] - a[1]);
    const lat1 = toRad(a[0]);
    const lat2 = toRad(b[0]);
    const aVal = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(aVal), Math.sqrt(1-aVal));
    return R * c;
}

/**
 * Calculate distance in kilometers between two points
 */
export function getDistanceKm(a: [number, number], b: [number, number]): number {
    return getDistanceMeters(a, b) / 1000;
} 